import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { User } from '../models/user.model';
import { LoginService } from './login.service';

@Injectable()
export class AuthGuard {

  /** Current {@link User}. */
  public user: User;

  constructor(
    private loginService: LoginService,
    private router: Router
  ) {
    this.loginService.getCurrentUser().subscribe(user => {
      this.user = user;
    });
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    return this.checkLogin(state.url);
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    return this.canActivate(route, state);
  }

  private checkLogin(url: string): boolean | UrlTree {
    if (this.user) {
      if (this.user.mail_verified === 0) {
        this.loginService.checkMailVerification().subscribe(session => {
          this.user = session.user;
        });
      }
      return true;
    } else {
      this.loginService.setRedirectUrl(url);
      return this.router.createUrlTree(['/login']);
    }
  }
}
